import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL_BASE + "api/admin/";

export async function getAllUsers() {
  try {
    const res = await axios.get(API_URL + "users", { headers: authHeader() });
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
}

export async function acceptUserById(userId) {
  try {
    const res = await axios.post(API_URL + "accept", { id: userId }, { headers: authHeader() });
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
}

export async function getRegisRequests() {
  try {
    const res = await axios.get(API_URL + "requests", {
      headers: authHeader(),
    });
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
}

export async function deleteUserById(id) {
  try {
    const res = await axios.delete(API_URL + `delete-user/${id}`, { headers: authHeader() });
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
}

export async function editUserRole(id, newRole) {
  try {
    const res = await axios.post(API_URL + `edit-role/${id}`, { role: newRole }, { headers: authHeader() });
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
}
